import React from "react";
import {
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  FormInput,
  ButtonGroup,
  ButtonToolbar
} from "../../components/ui";
import { Link } from "react-router-dom";

const Search = ({ onSearch, title }) => {
  return (
    <ButtonToolbar style={{ width: "100%", justifyContent: "space-between" }}>
      <InputGroup seamless style={{ width: "50%" }}>
        <InputGroupAddon type="prepend">
          <InputGroupText>
            <i className="material-icons">search</i>
          </InputGroupText>
        </InputGroupAddon>
        <FormInput
          placeholder="Search by post title"
          value={title}
          onChange={e => onSearch(e.target.value)}
        />
      </InputGroup>
      <ButtonGroup size="sm">
        <h6 style={{ alignSelf: "center" }} className="m-0">
          <Link to={`/add-new-post`}>Create New Post</Link>
        </h6>
      </ButtonGroup>
    </ButtonToolbar>
  );
};

export default Search;
